import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { hasOpenRegistrationEnabled, OrganizationService, SiteMembershipService } from '@se-po/shared-data-access-services'
import { map } from 'rxjs/operators'

export const openRegistrationRouteGuard: CanActivateFn = () => {
  const organizationService = inject(OrganizationService)
  const siteMembershipService = inject(SiteMembershipService)
  const router = inject(Router)

  return hasOpenRegistrationEnabled(organizationService, siteMembershipService).pipe(
    map((enabled) => enabled || router.createUrlTree(['user', 'registrations']))
  )
}
